import { React, useEffect,useState } from "react";
import { Link } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import styles from "./home.module.css";
import { auth } from "../../firebase";
import { useNavigate } from "react-router-dom";


function Home() {
  const [ButtonText,setButtonText] = useState("Play Video");
  const navigate = useNavigate();
  const [isVideoVisible, setVideoVisible] = useState(false);
  const handleButtonClick = () => {
    setVideoVisible(!isVideoVisible);
    setButtonText(isVideoVisible ? "Play Video" : "Stop Playing");
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // If the user is already logged in, redirect to the next page
        navigate("/Vehicletype");
      }
    });
    // Clean up the subscription when the component unmounts
    return () => unsubscribe();
  }, []);


  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <div className={styles.titleWrapper}>
            <h1 className={styles.title}>Track N Go</h1>
          </div>
          <div className={styles.btnClass}>
            <div className={styles.btnWrapper}>
            {/* <Link to="/abouttrackngo">About</Link> */}
              <Link to="/login" className={styles.loginBtn}>
                Login
              </Link>
              <Link to="/signup" className={styles.signupBtn}>
                Signup
              </Link>
            </div>
          </div>
        </div>
      </header>
      
      <div className={styles.content}>
      <p className={styles.visionH3_1}> Watch About our Product </p>
      <button onClick={handleButtonClick} className={styles.visionH3_4}>
         {ButtonText}
        </button>
        {isVideoVisible && (
          <div className={styles.videoContainer}>
            <iframe
              src="https://drive.google.com/file/d/18ZP-pqE6hd3hgu44jGHosvD76RfdPyMf/preview"
              width="1280"
              height="720"
              allow="autoplay"
              title="Track N Go Video"
              className={styles.videoIframe}
            ></iframe>
          </div>
        )}
        <div className={styles.back}>
        
      <p className={styles.next}>
      Start your journey with Track N Go by entering your vehicle details. Together, let's make every ride easy and efficient.
          </p>
          </div>
          
        
        <div className={styles.intro}>
        <h3 className={styles.introH3_1}>
            Amid the intricate challenges posed by urban living, the optimization of public transportation systems becomes a linchpin for creating seamless and efficient commuting experiences.
          </h3>
          
          <h3 className={styles.introH3_2}>
            Beyond the fundamental task of ensuring buses run on time, a more comprehensive goal emerges — that of enhancing the overall journey experience for urban commuters.
          </h3>
        </div>
        <h3 className={styles.visionH3_1}>
            It is against this backdrop that "Track N Go" emerges as a groundbreaking solution, poised to redefine the landscape of bus tracking and management, transcending both public and private sectors.
          </h3>
          <h3 className={styles.visionH3_2}>
            This innovative solution harnesses the ubiquitous nature of mobile phones and their inherent location tracking capabilities, presenting a disruptive approach to real-time bus tracking.
          </h3>
          <h3 className={styles.visionH3_3}>
            "Track N Go" makes real-time tracking accessible and scalable, creating a significant leap forward in the realm of urban transportation solutions.
          </h3>
          <h3 className={styles.visionH3_4}>
            By strategically leveraging mobile technology, the project not only meets the immediate need for efficient bus tracking but also lays the groundwork for a more inclusive, cost-effective, and user-centric approach to urban commuting.
          </h3>
          <h3 className={styles.visionH3_5}>
            This introduction encapsulates the project's commitment to innovation, efficiency, and the continual enhancement of the dynamic urban mobility landscape.
          </h3>
          <h3 className={styles.visionH3_6}>
            As we delve into the intricacies of "Track N Go," we unravel a narrative of forward-thinking technology, accessibility, and a transformative vision for the future of urban transportation.
          </h3>
         
      <footer className={styles.homefooter}>
           Developed by:
      <div className="developer-info">
        <a href="https://www.linkedin.com/in/shaik-mohammed-naveed-9ba4a5212/" >Shaik Mohammed Naveed </a>
      </div>
      <div className="developer-info">
        <a href="https://www.linkedin.com/in/mahika-dhar/" > Mahika Dhar M </a>
      </div>
      <div className="developer-info">
        <a href="https://www.linkedin.com/in/suhail-ahmed-8a78b5200/" > Suhail Ahmed</a>
      </div>
      <div className="developer-info">
        <a href="https://www.linkedin.com/in/utkarsh-kumar-58a586200/">Utkarsh Kumar</a> </div>
    </footer>
        </div>
      </div>
   
  );
}


export default Home;

